<template>
  <div :style="`height: ${height}px; width: ${width}px`">
    <input
      v-show="false"
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />
    <modal
      v-if="displayCropper"
      :value="displayCropper"
      headerClass="hide"
      class="no-background"
      style="max-height: 90vh;"
    >
      <vue-cropper
        style="min-height: 50px;"
        class="my-1"
        ref="cropper"
        :aspect-ratio="width / height"
      />
      <div class="buttons">
        <button
          @click="cropImage"
          name="crop"
          style="border-radius: 4px 0 0 4px; border-right: solid 1px black"
        >Crop</button>
        <button
          @click="cancelCrop"
          style="border-radius: 0 4px 4px 0"
        >Cancel</button>
      </div>
    </modal>

    <div
      v-else
      @click.prevent="$refs.input.click()"
      style="height: 100%; width: 100%"
    >
      <img
        :src="srcToDisplay"
        class="image"
        style="height: 100%; width: 100%"
      />

      <div
        v-if="showCameraIcon && !displayCropper"
        class="icon_wrapper"
      >
        <svg viewBox="0 0 24 24">
          <path :d="`
               M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1
               20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0
               ,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0
               12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1
               9,12A3,3 0 0,1 12,9Z`"></path>
        </svg>
      </div>
    </div>

  </div>
</template>
<script>
import CONSTANTS from '@/constants/constants';

export default {
  name: 'edit-image',

  components: {
    VueCropper: () => import('vue-cropperjs'),
  },

  data() {
    return {
      displayCropper: false,
      croppedImage: null,
    };
  },

  props: {
    value: { type: String, required: false },
    callback: { type: Function, required: true }, // method that will receive url
    width: { type: Number, required: false, default: 375 },
    height: { type: Number, required: false, default: 375 },
    pixelDensity: { type: Number, required: false, default: 3 },
    placeholder: { String, default: CONSTANTS.imagePlaceholderUrl },
    imageClass: { type: String, default: '' },
    showCameraIcon: { type: Boolean, required: false, default: false },
  },

  computed: {
    srcToDisplay() {
      return this.croppedImage || this.value || this.placeholder;
    },
  },

  methods: {
    startCrop(srcOrBytes, attemps = 0) {
      if (this.$refs.cropper) {
        this.$refs.cropper.replace(srcOrBytes);
        return;
      }

      if (attemps > 100) {
        return;
      }

      setTimeout(() => this.startCrop(srcOrBytes, attemps + 1), 200);
    },

    cancelCrop() {
      this.croppedImage = null;
      this.displayCropper = false;
    },

    cropImage() {
      this.$emit('start-save');
      this.displayCropper = false;

      // Make sure the result is the right size
      const canvas = this.$refs.cropper.getCroppedCanvas({
        width: this.width * this.pixelDensity,
        height: this.height * this.pixelDensity,
      });

      canvas.toBlob((blob) => {
        this.$upload(blob)
          .then(this.callback);
      });

      this.$emit('input', canvas.toDataURL());
    },

    setImage(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      this.displayCropper = true;
      reader.onload = (event) => {
        this.startCrop(event.target.result);
        this.$refs.input.value = null;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style lang="scss">
  .hide {
    display: none;
  }

  .buttons {
    z-index: 9999;
    display: flex;
    flex-direction: row;
    background: $color_black;

    button {
      background-color: $color_black;
      color: $color_white;
      z-index: 9999;
      width: 50%;
      padding: $base_spacing * 1;
      border: unset;
    }
  }

  .image {
    width: 100%;
    object-fit: cover;
  }

  .icon_wrapper {
    position: absolute;
    text-align: right;
    margin-top: -42px;
    padding-left: $base_spacing;

    svg {
      stroke: rgba(0, 0, 0, 0.44);
      opacity: .8;
      fill: white;
      margin-right: $base_spacing * 2;
      margin-bottom: $base_spacing * 2;
      height: 30px;
      width: 30px;
    }
  }
</style>
